<script>
import {useRolesStore} from "@/stores/roles.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterRolesTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useRolesStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.rolesStore.indexRoleOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Roles</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="role in rolesStore.getRoleOptions"
        v-bind="$attrs"
        :value="role.id"
        :label="role.display_name"
    />
  </div>
</template>

<style scoped>

</style>